<template>
  <div class="footer">
    <div
      id="contact"
      class="footer-contact d-flex flex-column justify-content-center align-items-center"
    >
      <div class="contact-title">
        私服123是您選擇私服遊戲推廣的最佳夥伴。
      </div>
      <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div class="contact-text">
          為您提供一個無憂無慮的推廣列表
          <br>
          讓您專注於私服遊戲的發展和經營
        </div>
        <div>
          <a
            href="https://line.me/ti/p/iSL4FzlQha"
            target="_blank"
            class="cta"
          >
            <span>立即洽詢</span>
            <svg
              viewBox="0 0 13 10"
              height="10px"
              width="15px"
            >
              <path d="M1,5 L11,5" />
              <polyline points="8 1 12 5 8 9" />
            </svg>
          </a>
        </div>
      </div>
    </div>
    <div class="footer_container">
      <a href="/">
        <img
          :src="require('@/assets/images/logo/slog.gif')"
          alt="gamex123"
        >
      </a>
      <div class="copyright">
        Copyright© gamex123 Inc. All Rights Reserved.
      </div>
    </div>
  </div>
</template>

<script>
export default {

  data() {
    return {
    }
  },

}
</script>

<style lang="scss" scoped>
.footer {
  position: relative;
  bottom: 0;
  background-color: #0c0c0c;
}
.footer-contact {
  min-height: 200px;
  width: 100%;
  padding: 30px 0 100px;
  background: linear-gradient(#000, #4000d1 70%, #0c0c0c );
  .contact-title {
    font-size: 42px;
    font-weight: 600;
    padding: 40px;
    color: #FFFC7D;
  }
  .contact-text{
    font-size: 30px;
    font-weight: 600;
    color: #ffffff;
    line-height: 1.5;
    margin-right: 5rem;
  }
}

.footer_container {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 0 auto;
  padding: 40px 2vw 40px 2vw;
}
.copyright {
  color: #b7b7b7;
}
.cta {
  position: relative;
  margin: auto;
  padding: 12px 18px;
  transition: all 0.2s ease;
  background: none;
}

.cta:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  border-radius: 50px;
  background: #2057cc;
  width: 45px;
  height: 45px;
  transition: all 0.3s ease;
}

.cta span {
 position: relative;
 font-family: "Ubuntu", sans-serif;
 font-size: 18px;
 font-weight: 700;
 letter-spacing: 0.05em;
 color: #99f9ff;
}

.cta svg {
 position: relative;
 top: 0;
 margin-left: 10px;
 fill: none;
 stroke-linecap: round;
 stroke-linejoin: round;
 stroke: #99f9ff;
 stroke-width: 2;
 transform: translateX(-5px);
 transition: all 0.3s ease;
}

.cta:hover:before {
 width: 100%;
 background: #2057cc;
}

.cta:hover svg {
 transform: translateX(0);
}

.cta:active {
 transform: scale(0.95);
}
@media screen and (max-width: 992px) {
  .footer-contact{
    .contact-title {
      font-size: 34px;
    }
  }
}
@media screen and (max-width: 768px) {
  .footer-contact{
    .contact-title {
      font-size: 30px;
    }
    .contact-text{
      font-size: 24px;
      margin-right: 0;
      margin-bottom: 3rem;
    }
  }
}
@media screen and (max-width: 576px) {
  .footer_container {
    width: 100%;
    flex-direction: column;
    align-items: center;
  }
  .copyright {
    margin-top: 1.5rem;
  }
  .footer-contact{
    .contact-title {
      font-size: 28px;
    }
    .contact-text{
      font-size: 18px;
    }
  }
}
</style>
